var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrowLongBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 10.75C16.2476 10.75 16.5834 10.4142 16.5834 10C16.5834 9.58579 16.2476 9.25 15.8334 9.25V10.75ZM3.63642 9.46967C3.34352 9.76256 3.34352 10.2374 3.63642 10.5303L8.40939 15.3033C8.70228 15.5962 9.17716 15.5962 9.47005 15.3033C9.76294 15.0104 9.76294 14.5355 9.47005 14.2426L5.22741 10L9.47005 5.75736C9.76294 5.46447 9.76294 4.98959 9.47005 4.6967C9.17716 4.40381 8.70228 4.40381 8.40939 4.6967L3.63642 9.46967ZM15.8334 9.25H4.16675V10.75H15.8334V9.25Z",
    fill: "#366EE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowLongBlue);
export default __webpack_public_path__ + "static/media/left_arrow_long_blue.9e5d19b155dea956df4f2abe896d9ad4.svg";
export { ForwardRef as ReactComponent };